/* Custom Javascript */


/*-----------------------------------------------------------------------------/
/ Smooth Scroll
/-----------------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href*="#"]')
    .forEach(anchor => {
      if (anchor.getAttribute('href') !== '#' && anchor.getAttribute('href') !== '#0') {
        anchor.addEventListener('click', function(e) {
          // On-page links
          if (
            location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && 
            location.hostname === this.hostname
          ) {
            // Get the target element
            const targetId = this.getAttribute('href').split('#')[1];
            const targetElement = document.getElementById(targetId) || 
                                 document.querySelector(`[name=${targetId}]`);
            
            // Check if the target exists
            if (targetElement) {
              // Prevent default behavior (adding hash to URL)
              e.preventDefault();
              
              // Scroll smoothly
              window.scrollTo({
                top: targetElement.offsetTop,
                behavior: 'smooth'
              });
              
              // Set focus on the target
              targetElement.focus();
              if (document.activeElement !== targetElement) {
                targetElement.setAttribute('tabindex', '-1');
                targetElement.focus();
              }
            }
          }
        });
      }
    });
});